import ValueOperatorMatcher from "./ValueOperatorMatcher"
import { NoopValueDecorator, UrlDecodeValueDecorator, ValueDecorator } from "./ValueDecorator"
import { HackleUser, TargetCondition, TargetKey } from "../../model/model"
import ConditionMatcher from "./ConditionMatcher"
import EvaluateRequest from "../EvaluateRequest"
import { EvaluatorContext } from "../evaluator/Evaluator"

export default class UserConditionMatcher implements ConditionMatcher {
  private readonly userValueResolver: UserValueResolver
  private readonly valueOperatorMatcher: ValueOperatorMatcher

  private readonly URL_HACKLE_PROPERTY_KEY_NAMES = ["pagePath", "host", "url", "queryParameter"]

  constructor(userValueResolver: UserValueResolver, valueOperatorMatcher: ValueOperatorMatcher) {
    this.userValueResolver = userValueResolver
    this.valueOperatorMatcher = valueOperatorMatcher
  }

  matches(request: EvaluateRequest, context: EvaluatorContext, condition: TargetCondition): boolean {
    const userValue = this.userValueResolver.resolveOrNull(request.user, condition.key)
    const valueDecorator = this.valueDecorator(condition.key)
    return this.valueOperatorMatcher.matches(userValue, condition.match, valueDecorator)
  }

  private valueDecorator(key: TargetKey): ValueDecorator {
    if (key.type === "HACKLE_PROPERTY" && this.URL_HACKLE_PROPERTY_KEY_NAMES.includes(key.name)) {
      return new UrlDecodeValueDecorator()
    }

    return new NoopValueDecorator()
  }
}

export class UserValueResolver {
  resolveOrNull(user: HackleUser, key: TargetKey): any | undefined {
    switch (key.type) {
      case "USER_ID":
        return user.identifiers[key.name]
      case "USER_PROPERTY":
        return user.properties[key.name]
      case "HACKLE_PROPERTY":
        return user.hackleProperties[key.name]
      default:
        throw new Error(`Unsupported TargetKeyType [${key.type}]`)
    }
  }
}
